import { WorkflowsFormBlock } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsForm/WorkflowsFormBlock';
import { WorkflowsTable } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsTable/WorkflowsTable';
import { useConfigurationContext } from 'src/provider/ConfigurationProvider';
import { EditWorkflowBlock } from 'src/pages/ConfigurationPage/WorkflowsTab/EditWorkflowBlock/EditWorkflowBlock';
import type { Workflow } from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';
import type { WorkflowListKey } from 'src/pages/ConfigurationPage/hooks/useConfigurationWorkflows';
import type { ConfigurationFormFieldsObject } from 'src/pages/ConfigurationPage/hooks/useConfigurationFormFields';

export const WorkflowsForm = ({
  formFieldsObject = {} as ConfigurationFormFieldsObject,
  readonly = true,
  compact = false,
  customWorkflows,
  defaultWorkflows,
  onWorkflowsChange = (() => {}) as (key: WorkflowListKey, data: Workflow[]) => void,
  onWorkflowAdd = (() => {}) as (workflow: Workflow) => void,
  onEditClick = () => {},
}: {
  formFieldsObject?: ConfigurationFormFieldsObject;
  readonly?: boolean;
  compact?: boolean;
  customWorkflows?: Workflow[];
  defaultWorkflows?: Workflow[];
  onWorkflowsChange?: (key: WorkflowListKey, data: Workflow[]) => void;
  onWorkflowAdd?: (workflow: Workflow) => void;
  onEditClick?: () => void;
}) => {
  const { isEditWorkflowMode } = useConfigurationContext();

  return isEditWorkflowMode ? (
    <EditWorkflowBlock
      onWorkflowAdd={onWorkflowAdd}
      onWorkflowsChange={(workflow, index) => {
        const newWorkflows = [...customWorkflows];
        newWorkflows[index] = workflow;

        onWorkflowsChange('pf_custom_workflows', newWorkflows);
      }}
      compact={compact}
    />
  ) : (
    <div className={'flex !flex-col gap-5 p-2'}>
      <WorkflowsFormBlock
        label={'Default Workflows'}
        compact={compact}
        isCustom={false}
        readonly={readonly}
        fields={[formFieldsObject.pf_default_workflow]}
      >
        <WorkflowsTable
          isCustom={false}
          workflows={defaultWorkflows}
          readonly={readonly}
          compact={compact}
          onChange={(workflow) => onWorkflowsChange('pf_default_workflow', workflow)}
        />
      </WorkflowsFormBlock>
      <WorkflowsFormBlock
        label={'Custom Workflows'}
        compact={compact}
        readonly={readonly}
        fields={[formFieldsObject.pf_custom_workflows]}
        onWorkflowAdd={onWorkflowAdd}
        onEditClick={onEditClick}
      >
        <WorkflowsTable
          isCustom={true}
          workflows={customWorkflows}
          readonly={readonly}
          compact={compact}
          onChange={(workflow) => onWorkflowsChange('pf_custom_workflows', workflow)}
        />
      </WorkflowsFormBlock>
    </div>
  );
};
